import script from "./couponGoodsList.vue?vue&type=script&setup=true&lang=js"
export * from "./couponGoodsList.vue?vue&type=script&setup=true&lang=js"

import "./couponGoodsList.vue?vue&type=style&index=0&id=cd3887fa&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd3887fa"]])

export default __exports__